<template>
    <div class="content-side">
        <div class="content">
            <ParseWysiwygForStatic :mainHeadline="title" :content="content.ops" :mid="menu_id" :id="id" />
        </div>
    </div>
</template>

<script setup>
import Delta from 'quill-delta'
import { ref, onMounted, watch } from 'vue'
import $ from 'jquery'
import { useRoute } from 'vue-router'
import ParseWysiwygForStatic from '@/components/parseWysiwygForStatic.vue'
import { useI18n } from 'vue-i18n'

const title = ref("")
const content = ref("")
const menu_id = ref(0)
const id = ref(0)
const $route = useRoute()
const { locale, t } = useI18n()

if ($route.params.locale) locale.value = $route.params.locale


onMounted(fetchPage)

watch($route, fetchPage)

function fetchPage() {
    if (/[vV]isitStaticPage/g.test($route.name)) $.ajax({
        url: `${process.env.VUE_APP_SERVER_ROOT}visit-static/${$route.params.school ? $route.params.school + '/' : ''}${$route.params.name}`,
        method: "GET",
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
        success(data) {
            if (data.STATUS) {
                title.value = data.TITLE;
                content.value = new Delta(data.CONTENT)
                menu_id.value = data.MID
                id.value = data.ID
            } else {
                alert("دریافت اطلاعات موفقیت آمیز نبود زیرا " + data.REASON)
                location.href = "/"
            }
        }
    })
}
</script>